import './cabinet-errors.scss';

import { SessionErrorItem } from '~pages/cabinet/errors/SessionErrorItem.tsx';
import { useErrorsList } from '~pages/cabinet/errors/use-errors-list.ts';
import { Preloader } from '~shared/ui';

export function ErrorsPage() {
	const { list, pending } = useErrorsList();

	return (
		<div className="cabinet-errors">
			<h1>Список Нарушений</h1>
			<div className="table-overlay">
				<table className="table">
					<thead>
						<tr>
							<th>Дата</th>
							<th>Сотрудник</th>
							<th>Участок</th>
							<th>Нарушение</th>
							<th>Устройство</th>
							<th>Кто еще отмечался с аппарата</th>
							<th>IP / сеть</th>
							<th>Фото</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{pending ? (
							<tr>
								<td colSpan={9} align="center">
									<Preloader />
								</td>
							</tr>
						) : (
							<>
								{list.map(itm => (
									<SessionErrorItem key={itm.id} error={itm} />
								))}
							</>
						)}
					</tbody>
				</table>
			</div>
		</div>
	);
}
